import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function ForgotPassword() {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        setMessage('');
        setError('');

        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}auth/forgot_password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email }),
            });

            const data = await res.json();

            if (res.ok) {
                setMessage(t('forgotPassword.codeSentMessage'));
            } else {
                throw new Error(data.message);
            }
        } catch (err) {
            setError(t('forgotPassword.errorMessage', { message: err.message }));
        }
    };

    return (
        <div className="login-container">
            <img src="/images/main_logo_horizontal_cinza.svg" alt="logo" />
            <form onSubmit={handleSubmit} className="login-form">
                <input
                    type="email"
                    placeholder={t('forgotPassword.emailPlaceholder')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button type="submit" disabled={!email}>
                    {t('forgotPassword.sendCodeButton')}
                </button>
                <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                    <Link to="/" style={{ color: 'red', fontSize: '0.9rem' }}>
                        {t('forgotPassword.backToLogin') || 'Voltar ao login'}
                    </Link>
                </div>
            </form>
            {message && <p style={{ color: 'green', marginTop: '1rem' }}>{message}</p>}
            {error && <p style={{ color: 'red', marginTop: '1rem' }}>{error}</p>}
        </div>
    );
}

export default ForgotPassword;